<template>
  <div class="address">
    <header class="flex-align sp">
      <p>
        收货地址<span class="tip" v-if="addressList.length"
          >(地址最多<span class="c-pink">10</span>条, 还能保存<span class="c-pink">{{ 10 - addressList.length }}</span
          >条)</span
        >
      </p>
      <div>
        <span v-if="10 > addressList.length" class="under-line add" @click="addAddress">新建地址</span>
      </div>
    </header>
    <div class="address-list" v-loading="isLoading">
      <div v-if="addressList.length">
        <div class="address-item flex-align sp" v-for="(item, index) in addressShowList" :key="index">
          <div>
            <p><span class="title">收货人:</span>{{ item.receiverName }}</p>
            <p><span class="title">联系方式:</span>{{  item.mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') }}</p>
            <div class="flex-start">
              <span class="title">收货地址:</span>
              <p style="max-width: 600px">{{ `${item.province}${item.city}${item.district}${item.details}` }}</p>
            </div>
          </div>
          <div class="operation">
            <div class="btn" :class="{ default: item.isDefault }" @click="setDefault(index)">
              {{ item.isDefault ? '默认地址' : '设为默认' }}
            </div>
            <p>
              <span class="under-line op" @click="editAddress(index, item)">编辑</span
              ><span class="under-line op" @click="deleteAddress(index)">删除</span>
            </p>
          </div>
        </div>
      </div>
      <WithoutData tip="暂时没有地址" v-else-if="!isLoading" />
    </div>
    <AddressEdit :preAddress="preAddress" :show.sync="show" :isDefault="!addressList.length" @success="editSuccess" />
  </div>
</template>

<script>
import AddressEdit from '../../components/business/address/addressEdit'
import WithoutData from '../../components/common/WithoutData'
import getAddress from '@/api/address'
export default {
  name: 'address',
  components: {
    AddressEdit,
    WithoutData
  },
  data() {
    return {
      editingIndex: -1,
      defaultIndex: -1,
      isLoading: false,
      show: false,
      preAddress: {},
      addressList: [],
      item: {}
    }
  },
  created() {
    this.getData()
  },
  computed: {
    addressShowList() {
      const onTop = [...this.addressList]
      onTop.sort((a, b) => b.isDefault - a.isDefault)
      return onTop
    }
  },
  methods: {
    // 设为默认
    setDefault(index) {
      const defaultIndex = this.defaultIndex
      if (index === defaultIndex) return
      getAddress
        .setDefaultAddress({
          id: this.addressList[index].id
        })
        .then(
          () => {
            if (defaultIndex >= 0) this.$set(this.addressList[defaultIndex], 'isDefault', false)
            this.$set(this.addressList[index], 'isDefault', true)
            this.defaultIndex = index
            this.$feedback.success('设置默认成功')
          },
          () => this.$feedback('设置默认失败')
        )
    },
    // 编辑
    editAddress(index, item) {
      this.preAddress = Object.assign({}, this.addressList[index])
      this.editingIndex = index
      this.show = true
      this.getData()
    },
    // 编辑地址回调事件
    editSuccess(data) {
      if (this.editingIndex >= 0) {
        // 编辑
        this.$set(this.addressList, this.editingIndex, data)
        this.editingIndex = -1
        // const datas = {
        //   id: this.item.id,
        //   accountId: this.item.accountId,
        //   mobile: this.item.mobile,
        //   receiverName: this.item.receiverName,
        //   province: this.item.province,
        //   provinceCode: 'provinceCode',
        //   city: this.item.city,
        //   cityCode: 'cityCode',
        //   district: this.item.district,
        //   districtCode: 'districtCode',
        //   details: this.item.details
        // }
        // getAddress.changeAddress(datas).then((res) => {
        //   console.log(res, 'res')
        // })
      } else {
        // 新增
        if (data.isDefault) {
          this.defaultIndex = 0
        }
        // this.addressList.push(data)
        this.getData()
      }
    },
    // 新建
    addAddress() {
      if (this.addressList.length >= 30) {
        return
      }
      this.preAddress = {}
      this.show = true
    },
    // 删除
    deleteAddress(index) {
      let address = this.addressList[index]
      getAddress
        .deleteAddress({
          id: address.id
        })
        .then(
          (res) => {
            if (res.status === 200) {
              this.$feedback('删除成功')
              if (address.isDefault) {
                this.defaultIndex = -1
              }
              this.addressList.splice(index, 1)
            } else {
              this.$feedback(res.message)
            }
          },
          () => this.$feedback('删除失败')
        )
    },
    // 获取地址数据
    getData() {
      this.isLoading = true
      getAddress
        .getAddressList({
          addressType: 2
        })
        .then(
          (res) => {
            const { data } = res
            // 默认地址放到第一个
            for (let i = 0; i < data.length; i++) {
              if (data[i].isDefault) {
                data.unshift(data.splice(i, 1)[0])
                this.defaultIndex = 0
                break
              }
            }
            this.addressList = data
            this.isLoading = false
          },
          () => {
            this.isLoading = false
          }
        )
    }
  }
}
</script>
<style lang="scss" scoped>
.flex-align {
  display: flex;
  align-items: center;
  width: 100%;
}
.flex-start {
  display: flex;
  align-items: flex-start;
  text-align: left;
}
.sp {
  justify-content: space-between;
}
.flex-grow {
  flex-grow: 1;
  text-align: center;
}
.under-line {
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    color: #333 !important;
  }
}

.address {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  background: #fff;
  padding: 40px;
  margin-bottom: 35px;
}
header {
  margin-bottom: 40px;
  color: #333;
  font-size: 24px;
  .c-pink {
    color: #df3d36;
    font-size: 20px;
  }
  .tip {
    color: #777;
    font-size: 20px;
  }
  .add {
    position: relative;
    font-size: 20px;
    &:before {
      position: absolute;
      display: inline-block;
      content: '';
      left: -27px;
      top: 50%;
      height: 2px;
      width: 17px;
      background: #666;
    }
    &:after {
      position: absolute;
      display: inline-block;
      content: '';
      height: 2px;
      width: 17px;
      background: #666;
      left: -27px;
      top: 50%;
      transform: rotate(90deg);
    }
  }
}
.address-list {
  text-align: left;
  font-size: 20px;
  color: #333;
  min-height: 700px;
}
.address-item {
  width: 100%;
  box-sizing: border-box;
  padding: 54px;
  border: 1px #e4e4e4 solid;
  border-bottom: none;
  .title {
    display: inline-block;
    width: 107px;
    text-align: right;
    margin-bottom: 8px;
    margin-right: 10px;
  }
  &:last-child {
    margin-bottom: 0;
    border-bottom: 1px #e4e4e4 solid;
  }
}
.operation {
  width: 133px;
  text-align: center;
  .btn {
    width: 133px;
    height: 40px;
    line-height: 40px;
    font-size: 18px;
    margin-bottom: 10px;
    border: 1px solid #333;
    text-align: center;
    transition: all 0.3s;
    cursor: pointer;
    &:hover {
      background: #000;
      color: #fff;
    }
    &.default {
      background: #000;
      color: #fff;
      cursor: default;
    }
  }
  .op {
    font-size: 14px;
    color: #666;
    &:first-child {
      margin-right: 37px;
    }
  }
}
</style>
